import { render, staticRenderFns } from "./AppPill.vue?vue&type=template&id=595c64f3&scoped=true"
import script from "./AppPill.vue?vue&type=script&lang=js"
export * from "./AppPill.vue?vue&type=script&lang=js"
import style0 from "./AppPill.vue?vue&type=style&index=0&id=595c64f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595c64f3",
  null
  
)

export default component.exports